<template>
    <div
        v-if="!disactive"
        :class="fieldClasses"
    >
        <label class="form-field__label" :for="name">{{ label }}</label>
        <input
            :type="type"
            :class="[
                'form-field__control',
                { 'form-field__control--error': errors !== null },
            ]"
            :name="name"
            :id="name"
            :value="modelValue"
            :placeholder="placeholder"
            :required="name != 'flat_number'"
            maxlength="150"
            @change="checkMail"
            @input="updateValue($event.target.value)"
        >
        <ul class="form-field__error" v-if="errors">
            <li v-for="error in errors" :key="error" v-html="error"></li>
        </ul>
        <ul class="form-field__error" v-if="emailUsed && register">
            <li>
                Ten adres e-mail już istnieje w systemie Med-Space, prosimy zalogować się
                <a href="/logowanie">TUTAJ</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: [
        'label',
        'type',
        'name',
        'placeholder',
        'size',
        'disactive',
        'errorMessages',
        'register',
        'modelValue',
    ],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            this.value = value;
            if (this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },

        checkMail() {
            if (this.register && this.name === 'email') {
                axios
                    .get('/api/checkMail', {
                        params: {
                            email: this.value,
                        },
                    })
                    .then((response) => {
                        this.emailUsed = response.data.data.isUsed;
                    });
            }
        },
    },
    data() {
        return {
            value: '',
            emailUsed: false,
        };
    },
    computed: {
        fieldClasses() {
            const classes = ['form-field'];
            if (this.size) {
                classes.push(this.size);
                if (this.size === 'form-group--small') {
                    classes.push('form-field--small');
                }
            }
            return classes;
        },
        errors: function () {
            if (
                this.errorMessages &&
                this.name in this.errorMessages &&
                this.value === ''
            ) {
                return this.errorMessages[this.name];
            }

            return null;
        },
    },
    watch: {
        errorMessages: function () {
            this.value = '';
        },
    },
};
</script>
